import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Article, PatchArticle } from '@thro-types/billing';

import { AxiosRequestConfig } from 'axios';

import { getArticle, getArticles, updateArticle } from 'api/billingService';

export const useGetArticleQuery = (id: string, config?: AxiosRequestConfig) => {
  const queryKey = ['articles', config ? JSON.stringify(config.params) : ''];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getArticle(id, config);
    }
  });
};

export const useGetArticlesListQuery = (config?: AxiosRequestConfig) => {
  const queryKey = ['articles', config ? JSON.stringify(config.params) : ''];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getArticles(config);
    },
    placeholderData: keepPreviousData
  });
};

export const useArticleMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['articles'];
  const update = useMutation<Article, Error, { sku: string; data: PatchArticle }>({
    mutationFn: async args => {
      return await updateArticle(args.sku, args.data, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { update } as const;
};
